import { Component, OnInit, Input } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-productdetail',
  templateUrl: './productdetail.page.html',
  styleUrls: ['./productdetail.page.scss'],
})
export class ProductdetailPage implements OnInit {
  @Input() code: string;
  @Input() product_type: string;
  isLoading: boolean = false;
  isProcessing: boolean = false;
  dataForm: FormGroup;
  products: any = [];
  categories: any = [];
  vendors: any = [];
  units: any = [];
  constructor(public modalController: ModalController, public alertController: AlertController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) { }

  ngOnInit() {
    this.dataForm = new FormGroup({
      'product_id': new FormControl(null, [Validators.required]),
      'category_id': new FormControl(null, [Validators.required]),
      'unit_id': new FormControl(null, [Validators.required]),
      'vendor_id': new FormControl(null, []),
      'status': new FormControl(true, [Validators.required]),
    });
    if (this.code != '') {
      this.getDetail();
    }
    this.getProducts();
    this.getCategories();
    this.getVendors();
    this.getUnits();
  }

  closeDialog() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  submitForm() {
    if (this.code == '') {
      this.add();
    } else {
      this.update();
    }
  }

  update() {
    this.isLoading = true;
    var formData = new FormData();
    for (let key in this.dataForm.value) {
      let value = this.dataForm.value[key];
      if (key == 'vendor_id') {
        if (value) {
          value = value.ID;
        } else {
          value = 0;
        }
      }
      if (key == 'product_id' || key == 'category_id' || key == 'unit_id') {
        value = value.ID;
      }
      if (key == 'status') {
        if (value == true) {
          value = 1;
        } else {
          value = 0;
        }
      }
      formData.append(key, value);
    }
    this.restApi.put('shop_product/' + this.code, formData).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.modalController.dismiss({
          'success': true
        });
      }
      this.commonFunctions.presentAlertConfirm('Information', data['message']);
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  add() {
    this.isLoading = true;
    var formData = new FormData();
    for (let key in this.dataForm.value) {
      let value = this.dataForm.value[key];
      if (key == 'vendor_id') {
        if (value) {
          value = value.ID;
        } else {
          value = 0;
        }
      }
      if (key == 'product_id' || key == 'category_id' || key == 'unit_id') {
        value = value.ID;
      }
      if (key == 'status') {
        if (value == true) {
          value = 1;
        } else {
          value = 0;
        }
      }
      formData.append(key, value);
    }
    this.restApi.post('shopadmin_product', formData).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.modalController.dismiss({
          'success': true
        });
      }
      this.commonFunctions.presentAlertConfirm('Information', data['message']);
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  getProducts() {
    this.restApi.get('productdropdown').subscribe((data: any) => {
      if (data['code'] == 200) {
        this.products = data['data'];
      } else {
        this.products = [];
      }
    }, (error: any) => {
      this.products = [];
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  getCategories() {
    this.restApi.get('categorydropdown').subscribe((data: any) => {
      if (data['code'] == 200) {
        this.categories = data['data'];
      } else {
        this.categories = [];
      }
    }, (error: any) => {
      this.categories = [];
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  getUnits() {
    this.restApi.get('unitdropdown').subscribe((data: any) => {
      if (data['code'] == 200) {
        this.units = data['data'];
      } else {
        this.units = [];
      }
    }, (error: any) => {
      this.units = [];
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  getVendors() {
    this.restApi.get('shopvendordropdown/0').subscribe((data: any) => {
      if (data['code'] == 200) {
        this.vendors = data['data'];
      } else {
        this.vendors = [];
      }
    }, (error: any) => {
      this.vendors = [];
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  getDetail() {
    this.isProcessing = true;
    this.restApi.get('shop_product/' + this.code).subscribe((data: any) => {
      this.isProcessing = false;
      if (data['code'] == 200) {
        this.dataForm.controls['product_id'].setValue({ ID: data['data']['product_id'], name: data['data']['product'] });
        this.dataForm.controls['category_id'].setValue({ ID: data['data']['category_id'], name: data['data']['category'] });
        this.dataForm.controls['unit_id'].setValue({ ID: data['data']['unit_id'], name: data['data']['unit'] });
        this.dataForm.controls['status'].setValue(data['data']['status']);
        if (data['data']['vendor_id']) {
          this.dataForm.controls['vendor_id'].setValue({ ID: data['data']['vendor_id'], name: data['data']['vendor'] });
        } else {
          this.dataForm.controls['vendor_id'].setValue(null);
        }
      }
    }, (error: any) => {
      this.isProcessing = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }
}
